export default () => import(/* webpackChunkName: 'coffee/activities/membership/qa' */ './Qa');
